import { app } from '../../../../../../app';
import { Controller } from './shared-folder-add-csa.controller';

app.component('companySharingCenterSharedFoldersAddCSA', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./shared-folder-add-csa.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.component.js